import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { settingsAPI } from '../../services/api';

interface SettingsState {
  settings: any;
  loading: boolean;
  error: string | null;
}

const initialState: SettingsState = {
  settings: {},
  loading: false,
  error: null,
};

export const fetchSettings = createAsyncThunk(
  'settings/fetchSettings',
  async (_, { rejectWithValue }) => {
    try {
      const response = await settingsAPI.getAll();
      return response.data.config;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.error || 'Eroare la încărcarea setărilor');
    }
  }
);

export const updateSetting = createAsyncThunk(
  'settings/updateSetting',
  async ({ key, value, description }: { key: string; value: any; description?: string }, { rejectWithValue }) => {
    try {
      const response = await settingsAPI.update(key, { value, description });
      return { key, ...response.data };
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.error || 'Eroare la actualizarea setării');
    }
  }
);

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSettings.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.settings = action.payload;
        state.error = null;
      })
      .addCase(fetchSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(updateSetting.fulfilled, (state, action) => {
        state.settings[action.payload.key] = {
          value: action.payload.value,
          description: action.payload.description,
          updatedAt: action.payload.updatedAt,
        };
      });
  },
});

export const { clearError } = settingsSlice.actions;
export default settingsSlice.reducer;
